import { z } from 'zod';
import { ErrorResponseDto_Error } from '../generated/openapi/pnr-integration';

export const ConnectErrorEnum = ErrorResponseDto_Error;
const connectError = z.enum(ErrorResponseDto_Error);

export const connectErrorbody = z.object({
  error: connectError,
  message: z.string(),
  statusCode: z.union([z.literal(400), z.literal(401)]),
});

export const connectRequestBody = z.object({
  code: z.string(),
  id: z.string(),
  organizationId: z.uuid(),
  requestToken: z.string(),
  userId: z.string(),
});

export type ConnectErrorEnumType = z.infer<typeof connectError>;
export type ConnectErrorBody = z.infer<typeof connectErrorbody>;
export type ConnectRequestBody = z.infer<typeof connectRequestBody>;
